import qs from "qs";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { matchPath, useHistory, useRouteMatch } from "react-router";

import { LayeredCircles } from "../components/atoms";
import CheckmarkIcon from "../components/atoms/icons/CheckmarkIcon";
import { usePortalRoutes } from "../hooks";
import { ModalContext, ModalProvider, ModalWrapper } from "../providers";
import { RouteFeature } from "../routes";

function GenericSecurePaymentMethod() {
  const match = useRouteMatch();
  const { createSiteOrEmbedLink } = usePortalRoutes();
  const history = useHistory();
  const { t } = useTranslation();
  const search = qs.parse(history?.location?.search, {
    ignoreQueryPrefix: true,
  }) as {
    result: string;
  };
  const { stackModal, hide } = useContext(ModalContext);
  const redirect = useCallback(() => {
    hide();
    if (matchPath(match.url, RouteFeature.SiteSecurePayment)) {
      history.push("/");
    } else {
      history.push(
        createSiteOrEmbedLink(
          RouteFeature.SiteTimetableType.replace(":viewType", "list"),
        ),
      );
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    stackModal(
      <ModalWrapper
        className="flex flex-col items-center gap-4 rounded-2xl px-6 py-8"
        onCancel={redirect}
      >
        {
          {
            VERIFICATION_NOT_REQUIRED: (
              <>
                <LayeredCircles intent="success" className="size-14">
                  <CheckmarkIcon pathClassName="stroke-success-500" />
                </LayeredCircles>
                <div className="flex w-full flex-col items-center gap-2">
                  <div className="flex text-center text-xl font-bold">
                    {t("pages.paymentVerification.authorizationNotNeeded.title")}
                  </div>
                  <div className="flex text-center font-medium text-gray-500">
                    {t(
                      "pages.paymentVerification.authorizationNotNeeded.description",
                    )}
                  </div>
                </div>
              </>
            ),
          }[search.result]
        }
      </ModalWrapper>,
    );
  }, [redirect, search.result, stackModal, t]);

  return <div />;
}

function GenericSecurePaymentMethodLayout() {
  return (
    <ModalProvider>
      <GenericSecurePaymentMethod />
    </ModalProvider>
  );
}

export { GenericSecurePaymentMethodLayout as GenericSecurePaymentMethod };
